import { IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { IPlan, Plan } from '../../entities/plan';
import { ProfileService } from '../profile/profile.service';

export interface IGetPlansRes {
  isError: boolean;
  plans: IPlan[];
}

export interface IBuyPlanRes {
  isError: boolean;
  text: string;
}

export class PlanService {
  static $inject = [
    '$http',
    'GmcApi',
    'ProfileService'
  ];
  private _plans: Plan[] = [];

  constructor( private $http: IHttpService,
               private gmcApi: GmcApi,
               private profileService: ProfileService ) {

  }

  get plans(): Plan[] {
    return this._plans;
  }

  getPlans(): IPromise<Plan[]> {
    return this.$http.get<IGetPlansRes>(this.gmcApi.plans.getPlans)
      .then(( res ) => {
        this._plans = res.data.plans.map(( plan ) => new Plan(plan));
        return this._plans;
      });
  }

  buyPlan( plan_id: string, plan_index: number ): IPromise<any> {
    return this.$http.post<IBuyPlanRes>(this.gmcApi.plans.buyPlan, { plan_id, plan_index })
      .then(( res ) => res.data);
  }


  revalidatePlan( monthNum: number): IPromise<any> {
    return this.$http.post<IBuyPlanRes>(this.gmcApi.plans.revalidatePlan, { month: monthNum})
      .then(( res ) => res.data);
  }
}



// WEBPACK FOOTER //
// ./app/core/services/plan/plan.service.ts